import React, { Component } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../actions";

import Header from "./Header";
import Latest from "./Latest";
import FindPromo from "./FindPromo";
import Explanation from "./Explanation";
import Mobile from "./Mobile";
import Upload from "./Upload";
import Couple from "./Couple";
import Ranking from "./Ranking";
import Publi from "./Publi";
import Footer from "./Footer";
const Dashboard = () => <h2>Dashboard</h2>;
const SurveyNew = () => <h2>SurveyNew</h2>;

class App extends Component {
  componentDidMount() {
    this.props.fetchUser();
  }
  render() {
    return (
      <div className="container">
        <BrowserRouter>
          <div>
            <Header />
            <Route exact path="/" component={Latest} />
            <Route exact path="/" component={FindPromo} />
            <Route exact path="/" component={Explanation} />
            <Route exact path="/" component={Mobile} />
            <Route exact path="/search" component={Upload} />
            <Route exact path="/couples/:id" component={Couple} />
            <Route exact path="/ranking" component={Ranking} />
            <Route exact path="/surveys" component={Dashboard} />
            <Route path="/surveys/new" component={SurveyNew} />
            <Publi />
            <Footer />
          </div>
        </BrowserRouter>
      </div>
    );
  }
}

export default connect(null, actions)(App);



// WEBPACK FOOTER //
// ./src/components/App.js